export default {
  title: 'Studio (V2)',
  description: 'Creați și gestionați site-ul restaurantului cu noul Website Studio.',
  retry: 'Încercați din nou',
  deleted: 'Proiect șters.',
  errors: {
    load: 'Proiectul Studio (V2) nu a putut fi încărcat.',
    create: 'Proiectul nu a putut fi creat. Vă rugăm să încercați din nou.',
    delete: 'Proiectul nu a putut fi șters. Vă rugăm să încercați din nou.',
  },
  EmptyState: {
    title: 'Încă nu există un proiect Studio (V2)',
    description: 'Creați un proiect pentru a construi site-ul în noul Website Studio. Studio (V1) rămâne neschimbat.',
    description_no_access: 'Un manager de onboarding poate crea proiectul pentru acest brand.',
    create: 'Creează proiect',
  },
  ProjectCard: {
    unnamed: 'Proiect fără nume',
    edit: 'Editează în Studio',
    delete: 'Șterge',
    open: 'Deschide',
    no_domain: 'Încă fără domeniu',
    fields: {
      uuid: 'UUID',
      domain: 'Domeniu',
      websites: 'Site-uri web',
    },
    delete_confirm: {
      title: 'Ștergeți acest proiect?',
      description: 'Această acțiune elimină proiectul Studio (V2) și site-urile sale. Puteți crea unul nou mai târziu.',
      ok: 'Șterge',
      cancel: 'Anulează',
    },
  },
};
